import { NumericRangeFilterOption } from '../types';
import { NumericRange } from '../../components';

export const config: NumericRangeFilterOption = {
  id: 'omicsExplorer.filters.variantAlleleFrequency',
  title: {
    id: 'omicsExplorer.filters.variantAlleleFrequency',
    defaultMessage: 'Variant Allele Frequency',
  },
  content: NumericRange,
  injectedProps: {
    id: 'variantAlleleFrequency',
    step: 0.01,
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    defaultMaximumValue: null,
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    defaultMinimumValue: null,
    searchKey: 'variantAlleleFrequency',
    buttonIntlLabel: {
      id: 'omicsExplorer.filters.variantAlleleFrequency.button.placeholder',
      defaultMessage: 'Add Filter',
    },
    maxHelpMessage: {
      id: 'omicsExplorer.filters.variantAlleleFrequency.maxHelpMessage',
      defaultMessage: '<= Max',
    },
    minHelpMessage: {
      id: 'omicsExplorer.filters.variantAlleleFrequency.minHelpMessage',
      defaultMessage: '>= Min',
    },
    maximumOption: {
      id: 'omicsExplorer.filters.variantAlleleFrequency.maxPlaceholderIntlLabel',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.variantAlleleFrequency.maxPlaceholderIntlLabel',
        defaultMessage: '0.50',
      },
    },
    minimumOption: {
      id: 'omicsExplorer.filters.variantAlleleFrequency.minPlaceholderIntlLabel',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.variantAlleleFrequency.minPlaceholderIntlLabel',
        defaultMessage: '0.20',
      },
    },
  },
};
